import React from 'react';

const TermsConditions = () => (
  <div className="bg-white p-8 rounded-lg shadow-lg">
    <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
    <p className="mb-4">
      For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere on this page shall mean AGA BOARD GAMES LLP, whose registered/operational office is 206, Man Excellenza, Sv Road, Vile Parle West Mumbai MAHARASHTRA 400056. "you", “your”, "user", “visitor” shall mean any natural or legal person who is visiting our website and/or agreed to purchase from us.
    </p>
    <p className="mb-4">
      Your use of the website and/or purchase from us are governed by the following Terms and Conditions:
    </p>
    <p className="mb-4">
      The content of the pages of this website is subject to change without notice.
    </p>
    <p className="mb-4">
      Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors, and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
    </p>
    <p className="mb-4">
      Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through our website and/or product pages meet your specific requirements.
    </p>
    <p className="mb-4">
      Our website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
    </p>
    <p className="mb-4">
      All trademarks reproduced on our website which are not the property of, or licensed to, the operator are acknowledged on the website.
    </p>
    <p className="mb-4">
      Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.
    </p>
    <p className="mb-4">
      From time to time, our website may also include links to other websites. These links are provided for your convenience to provide further information.
    </p>
    <p className="mb-4">
      You may not create a link to our website from another website or document without AGA BOARD GAMES LLP’s prior written consent.
    </p>
    <p className="mb-4">
      Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.
    </p>
    <p className="mb-4">
      We shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.
    </p>
  </div>
);

export default TermsConditions;
